import { render, staticRenderFns } from "./VehiclePrice.vue?vue&type=template&id=63a69a9e&scoped=true&"
import script from "./VehiclePrice.vue?vue&type=script&lang=js&"
export * from "./VehiclePrice.vue?vue&type=script&lang=js&"
import style0 from "./VehiclePrice.vue?vue&type=style&index=0&id=63a69a9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a69a9e",
  null
  
)

export default component.exports